import { TruckIcon } from '@heroiconsv2/react/24/outline'
import { isString, trim } from 'lodash'
import { formatPrice } from 'lib/utils'
import { LABEL, PANEL, ROW_START, SectionCard } from './BookingSection'

const BookingCarDetailsCard = ({ bookingData, t, isArabic }) => (
  <SectionCard
    icon={TruckIcon}
    title={t('booking.sections.carDetails')}
    right={
      bookingData?.rentalCar?.carImages?.[0]?.url ? (
        <img src={bookingData.rentalCar.carImages[0].thumbnailUrl || bookingData.rentalCar.carImages[0].url} alt="" className="h-12 w-20 rounded-lg object-cover" />
      ) : null
    }
  >
    <div>
      <div className={PANEL}>
        <div className={ROW_START}>
          <div className={LABEL}>{t('booking.labels.carName')}</div>
          <div className="text-sm sm:text-base text-slate-800 sm:text-right break-words">
            {(() => {
              const makeObj = bookingData?.rentalCar?.car?.make
              const modelObj = bookingData?.rentalCar?.car?.model
              const make = isString(makeObj) ? makeObj : isArabic && makeObj?.makeAr ? makeObj.makeAr : makeObj?.make || ''
              const model = isString(modelObj) ? modelObj : isArabic && modelObj?.modalAr ? modelObj.modalAr : modelObj?.modal || ''
              return trim(`${make} ${model} ${bookingData?.rentalCar?.modelYear || ''}`) || '-'
            })()}
          </div>
        </div>

        <div className={ROW_START}>
          <div className={LABEL}>{t('booking.labels.vin')}</div>
          <div className="text-sm sm:text-base text-slate-800 sm:text-right break-all">{bookingData?.rentalCar?.vin || '-'}</div>
        </div>

        <div className={ROW_START}>
          <div className={LABEL}>{t('booking.labels.registrationNumber')}</div>
          <div className="text-sm sm:text-base text-slate-800 sm:text-right break-all">{bookingData?.rentalCar?.registrationNumber || '-'}</div>
        </div>

        {(() => {
          const listRate = Number(bookingData?.dailyRate) || 0
          const discRate = Number(bookingData?.dailyDiscountRate) || 0
          const dailyRateValue = (discRate || listRate || 0) === 0 && bookingData?.rentalCarDailyRate ? Number(bookingData.rentalCarDailyRate) || 0 : listRate || discRate || 0
          // Show the discount rate as its own row only when a distinct discounted rate exists; otherwise hide it.
          const showDiscountRow = discRate > 0 && listRate > 0 && discRate !== listRate
          return (
            <>
              <div className={ROW_START}>
                <div className={LABEL}>{t('booking.labels.dailyRate')}</div>
                <div className="text-sm sm:text-base text-slate-800 sm:text-right">
                  {formatPrice(dailyRateValue, true)} {t('common.omr')}
                </div>
              </div>

              {showDiscountRow && (
                <div className={ROW_START}>
                  <div className={LABEL}>{t('booking.labels.dailyDiscountRate')}</div>
                  <div className="text-sm sm:text-base text-slate-800 sm:text-right">
                    {formatPrice(discRate, true)} {t('common.omr')}
                  </div>
                </div>
              )}
            </>
          )
        })()}

        <div className={ROW_START}>
          <div className={LABEL}>{t('booking.labels.bookingType')}</div>
          <div className="text-sm sm:text-base text-slate-800 sm:text-right">
            {bookingData?.bookingDurationType ? t(`carAuth.${bookingData.bookingDurationType}`, { defaultValue: bookingData.bookingDurationType }) : t('carAuth.dailyRate')}
          </div>
        </div>

        <div className={ROW_START}>
          <div className={LABEL}>{t('booking.labels.ajarleePercentage')}</div>
          <div className="text-sm sm:text-base text-slate-800 sm:text-right">{bookingData?.branchDiscount?.ajarleePercentage || 0}</div>
        </div>

        <div className={ROW_START}>
          <div className={LABEL}>{t('booking.labels.companyPercentage')}</div>
          <div className="text-sm sm:text-base text-slate-800 sm:text-right">{bookingData?.branchDiscount?.companyPercentage || 0}</div>
        </div>
      </div>
    </div>
  </SectionCard>
)

export default BookingCarDetailsCard
